const TYPES = [
  'LML:route:nav', //1
  'LML:routeBoard:nav', //2
  'LML:routeFulfillment:nav', //3
  'LML:routeAssignment:nav', //4
  'LML:routePreAssignment:nav', //5
  'LML:route:create', //6
  'LML:route:edit', //7
  'LML:route:delete', //8
  'LML:route:cancel', //9
  'LML:routeEvents:nav', //10
  'LML:routeTemplates:activate', //11
  'LML:routeTemplates:delete', //12
  'LML:routeTemplates:edit', //13
  'LML:routeTemplates:nav', //14
  'LML:routeTemplates:schedule', //15
  'LML:routeTemplates:view', //16
  'LML:clientNotification:nav', //17
  'LML:webNotification:nav', //18
  'LML:gpsEvaluationTime:nav', //19
  'LML:report:nav', //20
  'LML:indicator:nav', //21
  'LML:secureMode:nav', //22
  'LML:motivesAndSubmotives:nav', //23
  'LMB:planner:nav', //24
  'LMB:tracking:nav', //25
  'LMB:user:nav', //26
  'LMB:vehicle:nav', //27
  'LMB:report:nav', //28
  'LMB:clientNotification:nav', //29
  'LMB:clientConfiguration:nav', //30
  'LMB:tag:nav', //31
  'LMB:tag:create', //32
  'LMB:tag:edit', //33
  'LMB:tag:activate', //34
  'LMB:sender:nav', //35
  'LMB:sender:create', //36
  'LMB:sender:edit', //37
  'LMB:sender:delete', //38
  'LMB:motive:nav', //39
  'LMB:motive:create', //40
  'LMB:motive:edit', //41
  'LMB:motive:delete', //42
  'LMB:vehicletype:nav', //43
  'LMB:vehicletype:create', //44
  'LMB:vehicletype:edit', //45
  'LMB:vehicletype:delete', //46
  'LMB:billingInformation:nav', //47
  'LML:tag:nav', //48
  'LML:tag:create', //49
  'LML:tag:edit', //50
  'LML:tag:activate', //51
  'LMB:routePreAssignment:nav', //52
  'LML:indicatorV2:nav' //53
];

const canUserAccess = (idClient, permType, store) => {
  const permissions = store.getters.permissionUser;
  const permsByClient = permissions[idClient];
  if (!permsByClient) {
    return false;
  }
  return permsByClient.includes(TYPES[Number(permType) - 1]);
};

const hasPermission = (permission, store) => {
  let rawpermissions = store.getters.permissionUser;
  let permissions = [];
  if (typeof rawpermissions === 'object') {
    Object.keys(rawpermissions).forEach((k) => {
      let rawArray = rawpermissions[k];
      if (Array.isArray(rawArray)) {
        permissions = [...permissions, ...rawArray];
      }
    });
  }
  console.log(permissions);
  return permissions.includes(permission) || permissions.includes('COR:*');
};

module.exports = { canUserAccess, hasPermission };
